import { mexicoStates } from "@/utils/constants";

interface ReportAddressFormData {
  street: string;
  exterior_number: string;
  interior_number: string;
  neighborhood: string;
  municipality: string;
  city: string;
  state: string;
  zip_code: string;
}

// Last-mile defense before sending address to mb_platform/mb-sic-api/BDC.
// Idempotent: upper + strip diacritics + collapse spaces + trim. Safe to
// re-apply over already-sanitized values that came from inputs/SEPOMEX.
const DIACRITICS = /[\u0300-\u036f]/g;
const sanitizeForBackend = (value: string): string => {
  if (!value) return value;
  return value
    .toUpperCase()
    .normalize("NFD")
    .replace(DIACRITICS, "")
    .replace(/\s+/g, " ")
    .trim();
};

export const normalizeReportStateForSubmit = (state: string): string => {
  if (!state) {
    return state;
  }

  return mexicoStates[state] ?? state;
};

export const buildReportAddressPayload = (formData: ReportAddressFormData) => ({
  street: sanitizeForBackend(formData.street),
  exterior_number: sanitizeForBackend(formData.exterior_number),
  interior_number: sanitizeForBackend(formData.interior_number),
  neighborhood: sanitizeForBackend(formData.neighborhood),
  municipality: sanitizeForBackend(formData.municipality),
  city: sanitizeForBackend(formData.city),
  state: normalizeReportStateForSubmit(formData.state),
  zip_code: formData.zip_code,
});
